const { html } = window;

export default () => `
<div class="Loader js-es6loader">
    <div class="Loader-display"></div><br>
    <span class="Loader-text">${html('loading')}</span>
</div>
`;
